import axios from "axios";
import Env from "@/logics/Envs.js";

export default async function (classId, students) {
    try {
        const toSend = new FormData();
        toSend.append("classId", classId);
        toSend.append("newStudentList", JSON.stringify(students));

        const res = await axios.post(Env.apiPath + "updateClassStudents", toSend);
        return res.data.error;
    } catch (err) {
        return err;
    }
}